"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _react = _interopRequireWildcard(require("react"));

var _uniqueId = _interopRequireDefault(require("lodash/uniqueId"));

var _victory = require("victory");

var _popover = _interopRequireDefault(require("@amzn/meridian-tokens/component/popover"));

var _theme = require("../theme");

var _cssRgbToHex = _interopRequireDefault(require("./../_utils/css-rgb-to-hex"));

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

/**
 * A Meridian-ized version of VictoryTooltip. API is identical.
 */
var VictoryTooltip = function VictoryTooltip(props) {
  var t = (0, _theme.useTheme)(_popover["default"], "popover");
  var id = (0, _react.useMemo)(function () {
    return (0, _uniqueId["default"])("mdn-victory-tooltip");
  }, []);

  var _useMemo = (0, _react.useMemo)(function () {
    return (0, _cssRgbToHex["default"])(t("dropShadowColor"));
  }, [t]),
      _useMemo2 = (0, _slicedToArray2["default"])(_useMemo, 2),
      floodColor = _useMemo2[0],
      floodOpacity = _useMemo2[1];

  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("defs", null, /*#__PURE__*/_react["default"].createElement("filter", {
    id: id
  }, /*#__PURE__*/_react["default"].createElement("feDropShadow", {
    dx: parseInt(t("dropShadowOffsetX")),
    dy: parseInt(t("dropShadowOffsetY")),
    stdDeviation: parseInt(t("dropShadowBlur")),
    floodColor: floodColor,
    floodOpacity: floodOpacity
  }))), /*#__PURE__*/_react["default"].createElement(_victory.VictoryTooltip, (0, _extends2["default"])({}, props, {
    style: {
      fill: t("foregroundColorOutline")
    },
    constrainToVisibleArea: true,
    cornerRadius: t("borderRadius"),
    flyoutPadding: {
      top: t("spacingInsetVerticalSmall"),
      bottom: t("spacingInsetVerticalSmall"),
      right: t("spacingInsetHorizontalMedium"),
      left: t("spacingInsetHorizontalMedium")
    },
    flyoutStyle: {
      fill: t("backgroundColorOutline"),
      stroke: t("borderColorOutline"),
      strokeWidth: t("borderWidth"),
      filter: "url(#".concat(id, ")")
    },
    pointerLength: t("arrowHeight"),
    pointerWidth: t("arrowWidth")
  })));
};

var _default = VictoryTooltip;
exports["default"] = _default;